










import store from '@/store'
import ApiClient from '@/js/api.js'
import ManageBase from '@/views/organisms/ManageBase.vue'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import SendUserForm from '@/views/templates/SendUserForm.vue'

export default
  components: {
    ManageBase
    Pankuzu
    Title
    SendUserForm
  }

  beforeCreate: () ->
    window.scrollTo(0, 0)

  created: () ->
    @$emit('set_color', true)
    if await store.getters.isLogin
      @$router.push '/mypage'
  methods: {
    go_back: (e) ->
      if $cookies.isKey('user_append_url')
        @$router.push $cookies.get('user_append_url')
      else
        @$router.push '/'
  }

